import { placeholderConfluenceDummyLinkCoUseDismissedResource } from '@jira/router-resources__placeholder-template-dismissed/src/placeholderConfluenceDummyLinkCoUseDismissedResource.tsx';
import { placeholderConfluenceDummyLinkDismissedResource } from '@jira/router-resources__placeholder-template-dismissed/src/placeholderConfluenceDummyLinkDismissedResource.tsx';
import { fetchSiteTraitsResource } from '@jira/router-resources__recommendations/src/fetchSiteTraitsResource.tsx';
import { fetchSiteUserTraitsResource } from '@jira/router-resources__recommendations/src/fetchSiteUserTraitsResource.tsx';
import { resourceWithCondition } from '@jira/router-resources__utils/src/resourceWithCondition.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { expVal } from '@atlassian/jira-feature-experiments';
import type { RouteResource } from '@atlassian/react-resource-router';
import { devaiIssueViewResource } from './devaiIssueViewResource.tsx';
import { rovoDevEntitlementResource } from './rovoDevEntitlementResource.tsx';
import { connectedToIssueAggDataResource } from './connectedToIssueAggDataResource.tsx';
import { ecosystemConnectBackgroundScriptsResource } from './ecosystemConnectBackgroundScriptsResource.tsx';
import { shadowIssueViewRelayResource } from './shadowIssueViewRelayResource.tsx';
import { issueViewDevPanelDataResource } from './issueViewDevPanelDataResource.tsx';

/**
 * Returns route resources that optimise issue view performance.
 *
 * Use this in routes that use:
 * - embeddedIssuePreloadLayoutBuilder([{ query: ['selectedIssue'] }])
 * - LazyIssueApp in afterPaint
 *
 * Including these resources will preload issue view data when an issue is selected,
 * improving perceived performance. However, issue view will still work without these
 * resources - data will be fetched on demand using useLazyLoadQuery instead.
 *
 * Use when:
 * - The route commonly opens issues (e.g., board, backlog, calendar views)
 */

export const getIssueViewResources = ({
	disableShadowQuery = false,
}: {
	disableShadowQuery?: boolean;
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
} = {}): RouteResource<any>[] => [
	resourceWithCondition(
		() => expVal('jpx-000-shadow-relay-query', 'isEnabled', false) && !disableShadowQuery,
		shadowIssueViewRelayResource,
	),
	resourceWithCondition(() => fg('dfo_connectedtoissueaggquery'), connectedToIssueAggDataResource),
	resourceWithCondition(() => fg('devai_issue_view_query_separation'), devaiIssueViewResource),
	resourceWithCondition(
		() => fg('nike-dfo-ecosystem-bg-scripts-migration-router'),
		ecosystemConnectBackgroundScriptsResource,
	),
	resourceWithCondition(
		() => fg('devpanel-relay-resource') && !fg('jiv-22469-dev-summary-to-miaq'),
		issueViewDevPanelDataResource,
	),
	resourceWithCondition(() => fg('jira-fix-build-dev-panel-fg'), rovoDevEntitlementResource),
	placeholderConfluenceDummyLinkDismissedResource,
	placeholderConfluenceDummyLinkCoUseDismissedResource,
	fetchSiteTraitsResource,
	fetchSiteUserTraitsResource,
];
